<button
    *ngIf="{ isDisabled: disabled | async } as data"
    type="button"
    [disabled]="data.isDisabled ? 'disabled' : undefined"
    class="aa-btn"
    [class.masked]="data.isDisabled === null"
    [ngClass]="getClassNames()"
    (click)="onClick()"
    [style.width.px]="btnWidth"
>
    <span>
        <i class="fad fa-fw" aria-hidden="true"></i>&nbsp;
        {{ btnText }}&nbsp;
        <i *ngIf="data.isDisabled === null" class="fad fa-fw fa-spinner fa-spin" aria-hidden="true"></i>
        <i *ngIf="data.isDisabled !== null" class="fad fa-fw" aria-hidden="true"></i>
    </span>
</button>
